export const googleAnalyticsConfig = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const APP_NAME = 'FitFace';
